import type {
  JointAxisVisualizationSlice,
  JointAxisVisualizationState,
  ViewerSliceCreator,
} from "./types";

export const jointAxisVisualizationInitialState: JointAxisVisualizationState = {
  jointAxisVisualization: null,
};

export const createJointAxisVisualizationSlice: ViewerSliceCreator<JointAxisVisualizationSlice> = (set) => ({
  ...jointAxisVisualizationInitialState,

  setJointAxisVisualization: (msg) =>
    set((state) => {
      if (msg.show) {
        state.jointAxisVisualization = {
          show: true,
          jointType: msg.joint_type,
          position: msg.position,
          axis: msg.axis,
          quaternion: msg.quaternion,
          minAngle: msg.min_angle,
          maxAngle: msg.max_angle,
          currentAngle: msg.current_angle,
        };
      } else {
        state.jointAxisVisualization = null;
      }
    }),
});
